import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';

export default class InterceptsServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        { name: 'SurveyReportDeliver', label: 'Survey Report Deliver' },
        { name: (item) => Array.isArray(item.SpecialLocations) ? item.SpecialLocations.join(', ') : (item.SpecialLocations || ''), label: 'Special Locations' },
        { name: (item) => Array.isArray(item.LocationType) ? item.LocationType.join(', ') : (item.LocationType || ''), label: 'Location Type' },
        { name: 'LocationTypeDetails', label: 'Location Type Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'LocationListSource', label: 'Location List Source' },
      ],
    },
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: 'NumResponsesRequested', label: 'Number of Responses Requested' },
        { name: 'NumLocations', label: 'Number of Locations' },
        { name: 'NumInterviewersPerLocation', label: 'Number of Interviewers per Location' },
        { name: 'LengthOfSurvey', label: 'Length of Survey' },
        { name: 'TabletOrPaper', label: 'Tablet or Paper?' },
        { name: 'InLocationOrEntrance', label: 'In the Location/Store or Entrance?' },
        { name: (item) => JsxHelper.YesNo(item.AuthorizationLetterProvided), label: 'Authorization Letter Provided?' },
        { name: 'IncentivesDescription', label: 'Incentives (please describe)' },
        { name: 'IncentiveCoordinationDescription', label: "If there are incentives, how will IC's coordinate incentive distribution?" },
        { name: (item) => JsxHelper.YesNo(item.IccoordinatorBilingualRequired), label: 'Does IC Coordinator Need to be Bilingual?' },
        { name: 'BareOrClientSurvey', label: 'BARE Provides Survey or Client Provides Survey' },
        { name: (item) => JsxHelper.YesNo(item.IncentiveProvidedByBare), label: 'Incentive Provided by BARE?' },
      ],
    },
    {
      tabName: 'Survey',
      tabLabel: 'Survey',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.TranslationProvided), label: 'Translation of Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
      ],
    },
    {
      tabName: 'Demographics',
      tabLabel: 'Demographics',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: 'OtherDemographicRequirements', label: 'Other Demographic Requirements' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
